export default {"src":"/_next/static/media/nakheelLogo.c23048fc.svg","height":39,"width":104,"blurWidth":0,"blurHeight":0};